import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import typographyStyles from './Typography.module.css.js';
export { default as typographyStyles } from './Typography.module.css.js';

var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function createTypographyComponent(type, typographyClassNames) {
  return /*#__PURE__*/forwardRef(function (_ref, ref) {
    var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/createElement(type, _objectSpread({
      ref: ref,
      className: cn(typographyClassNames(restProps), className)
    }, restProps));
  });
}
var PageTitle = createTypographyComponent('h1', function () {
  return typographyStyles.pageTitle;
});
var PageSubtitle = createTypographyComponent('h2', function () {
  return typographyStyles.pageSubtitle;
});
var H3 = createTypographyComponent('h3', function () {
  return typographyStyles.heading3;
});
var AccentText = createTypographyComponent('span', function () {
  return typographyStyles.accentText;
});
var SmallText = createTypographyComponent('span', function (_ref2) {
  var _cn;
  var semibold = _ref2.semibold,
    upper = _ref2.upper;
  return cn(typographyStyles.smallText, (_cn = {}, _defineProperty(_cn, typographyStyles.smallText_semibold, semibold), _defineProperty(_cn, typographyStyles.smallText_upper, upper), _cn));
});
var Subtitle = createTypographyComponent('span', function () {
  return typographyStyles.subtitle;
});
var Text = createTypographyComponent('span', function (_ref3) {
  var italic = _ref3.italic;
  return cn(typographyStyles.text, _defineProperty({}, typographyStyles.text_italic, italic));
});
var MonoText = createTypographyComponent('span', function (_ref4) {
  var bold = _ref4.bold;
  return cn(typographyStyles.monoText, _defineProperty({}, typographyStyles.monoText_bold, bold));
});

export { AccentText, PageTitle as H1, PageSubtitle as H2, H3, MonoText, PageSubtitle, PageTitle, SmallText, Subtitle, Text, createTypographyComponent };
